import { property } from 'lodash-es';
import { ColDef } from 'ag-grid-community';
import { name } from '@mummssoftware/utils/formatters';
import { NoteCountCellRenderer } from './CellRenderer';

const frequencyFormatter = ({ data }: any) => {
  const { frequency, period } = data;
  return `${frequency}/${period}`;
};

export const noteColumn: ColDef = {
  headerName: '',
  field: 'note_count',
  cellClass: 'no-border no-pad',
  suppressMenu: true,
  cellRendererFramework: NoteCountCellRenderer,
  width: 38,
  pinned: 'left',
};

export const crossPatientColumnDefs: ColDef[] = [
  {
    headerName: 'Patient Name',
    valueGetter: ({ data }) =>
      name(data.patientfirstname, data.patientlastname),
    width: 150,
    pinned: 'left',
  },
  {
    headerName: 'ID',
    valueGetter: ({ data }) => data.patientnumber,
    width: 80,
    pinned: 'left',
  },
];

export const staticColDefs: ColDef[] = [
  {
    headerName: 'Task',
    valueGetter: property('data.tasktext'),
    width: 175,
    pinned: 'left',
  },
  {
    headerName: 'PLANNED',
    valueGetter: frequencyFormatter,
    width: 110,
    pinned: 'left',
  },
];

export const getColumnDefs = (
  hasPatient: boolean,
  smallWidget: boolean,
  weekColumns: any,
) => {
  const columnDefs = [noteColumn];
  if (!hasPatient) {
    columnDefs.push(...crossPatientColumnDefs);
  }
  columnDefs.push(...staticColDefs);
  if (!smallWidget) {
    columnDefs.push(...weekColumns);
  }
  return columnDefs;
};
